import { queryKeys } from '@/hooks/constants';
import { useMutationWithLogging } from '@/hooks/useMutationWithLogging';
import { useQueryWithLogging } from '@/hooks/useQueryWithLogging';
import Service from '@/lib/App';

export function useGetDiff(
  variableName: string,
  diffId: string,
  options?: { [key: string]: any },
) {
  return useQueryWithLogging({
    queryKey: queryKeys.planner.getDiff(diffId),
    queryFn: () => Service.planner.getRolloutDiff(variableName, diffId),
    ...options,
  });
}

export function useApproveDiff(options?: { [key: string]: any }) {
  return useMutationWithLogging({
    mutationFn: async ([variableName, diffId, approvalLink = '']: [
      string,
      string,
      string,
    ]) => await Service.planner.approveDiff(variableName, diffId, approvalLink),
    ...options,
  });
}
